import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MonitoramentoRoutingModule } from './monitoramento-routing.module';
import { MonitoramentoComponent } from './monitoramento.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ChartModule } from 'primeng/chart';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RatingModule } from 'primeng/rating';


@NgModule({
	declarations: [
		MonitoramentoComponent
	],
	imports: [
		CommonModule,
		MonitoramentoRoutingModule,
		FormsModule,
		TableModule,
		ButtonModule,
		RippleModule,
		DropdownModule,
		InputTextModule,
		InputTextareaModule,
		ChartModule,
		ProgressSpinnerModule,
		RatingModule
	]
})
export class MonitoramentoModule { }
